import { render } from "./view.vue?vue&type=template&id=09f2e93b"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"
script.render = render

export default script